<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-sm-8 col-md-6 col-lg-5">
          <div class="card p-4">
            <div class="card-body">
              <form @submit.prevent="submitForm">
                <h1>{{ $t('common.login.header') }}</h1>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="icon-user"></i>
                    </div>
                  </div>
                  <input type="text"
                         class="form-control"
                         v-bind:class="{ 'is-invalid': $v.username.$error }"
                         v-bind:placeholder="$t('common.username')"
                         v-model="$v.username.$model"
                         autocomplete="username email"/>
                  <div class="invalid-feedback" v-if="!$v.username.required">
                    {{ $t('error.fieldRequired') }}
                  </div>
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="icon-lock"></i>
                    </div>
                  </div>
                  <input type="password"
                         v-bind:class="{ 'is-invalid': $v.password.$error }"
                         class="form-control"
                         v-bind:placeholder="$t('common.password')"
                         v-model="$v.password.$model"
                         autocomplete="current-password"/>
                  <div class="invalid-feedback" v-if="!$v.password.required">
                    {{ $t('error.fieldRequired') }}
                  </div>
                </div>
                <div class="alert alert-danger" v-if="errorMessage" role="alert">{{ errorMessage}}</div>
                <button class="btn btn-primary px-4" type="submit">{{ $t('common.login') }}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import auth from '@Service/auth';
  import { required } from 'vuelidate/lib/validators';

  export default {
    created: () => {
    },
    data: () => ({
      username: '',
      password: '',
      errorMessage: '',
    }),
    validations: {
      username: {
        required,
      },
      password: {
        required,
      },
    },
    watch: {
      password: function () {
        this.errorMessage = '';
      },
      username: function () {
        this.errorMessage = '';
      },
    },
    methods: {
      submitForm() {
        this.errorMessage = '';
        this.$v.$touch();
        if (!this.$v.$invalid) {
          auth.login(this.username, this.password)
            .catch(() => this.errorMessage = 'Podany login i/lub hasło są nieprawidłowe');
        }
      }
    },
  };
</script>
